import {
  Stack,
  Container,
  Flex,
  Box,
  Link,
  Text,
  Heading,
  ListItem,
  UnorderedList,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Divider,
  Badge,
} from "@chakra-ui/react";
import CombinedHeading from "../../common/CombinedHeading";
// import { motion } from "framer-motion";

export default function GrpcSampleProjects() {

  const grpcBlogs = [
    {
      id: 1,
      blogName:
        "How to stream real-time Solana Transactions using Shyft's gRPC Service",
      blogLink:
        "https://blogs.shyft.to/how-to-stream-real-time-solana-transactions-using-shyfts-grpc-service-1a8f8ad44da3?shyft-website",
      isNew: false,
    },
    {
      id: 2,
      blogName: "How to track new pools on Raydium with Shyft gRPC",
      blogLink:
        "https://blogs.shyft.to/how-to-track-new-pools-on-raydium-with-shyft-grpc-2497df832ea0?source=shyft-website",
      isNew: false,
    },
    {
      id: 3,
      blogName:
        "Launching liquidity pools on Raydium with safeguarding strategy to counter bot manipulation",
      blogLink:
        "https://blogs.shyft.to/launching-liquidity-pool-on-raydium-and-safeguarding-strategies-to-counter-bot-manipulation-part-1-a675f782382c?source=shyft-website",
      isNew: false,
    },
    {
      id: 4,
      blogName: "How to track new pools on Raydium with Shyft gRPC",
      blogLink:
        "https://blogs.shyft.to/how-to-build-a-bot-for-listening-to-new-raydium-pools-with-shyft-grpcs-600e1034277e?source=shyft-website",
      isNew: false,
    },
    {
      id: 4,
      blogName:
        "Real-time Solana Data Streaming with gRPC: Account, Transactions, and Blocks",
      blogLink:
        "https://blogs.shyft.to/real-time-data-streaming-with-grpc-accounts-transactions-blocks-734733e491ea?source=shyft-website",
      isNew: false,
    },
    {
      id: 5,
      blogName: "How to stream real-time Pump.fun updates on Solana",
      blogLink:
        "https://blogs.shyft.to/how-to-stream-real-time-pump-fun-updates-on-solana-29a46922ac5d?source=shyft-website",
      isNew: false,
    },
    {
      id: 6,
      blogName:
        "How to stream Solana Moonshot transactions in real-time with gRPC",
      blogLink:
        "https://blogs.shyft.to/how-to-stream-solana-moonshot-transactions-in-real-time-with-grpc-9b514099e1e4?source=shyft-website",
      isNew: false,
    },
    {
      id: 7,
      blogName: "How to stream Bonding Curve Transactions on Pump.fun",
      blogLink:
        "https://blogs.shyft.to/how-to-stream-bonding-curve-transactions-on-pumpfun-b422f5958c7f?source=shyft-website",
      isNew: false,
    },
    {
      id: 8,
      blogName: "How to stream new token launches on Pump.fun in real-time",
      blogLink:
        "https://blogs.shyft.to/how-to-stream-new-token-launches-on-pump-fun-in-real-time-188a6f9fa3fb?source=shyft-website",
      isNew: false,
    },
    {
      id: 9,
      blogName: "How to track token transfers from Pump.fun to Raydium",
      blogLink:
        "https://blogs.shyft.to/how-to-track-token-transfers-from-pump-fun-to-raydium-5ada83c2ac58?source=shyft-website",
      isNew: false,
    },
    {
      id: 10,
      blogName: "How to get parsed Pumpswap AMM Pools on Solana",
      blogLink:
        "https://blogs.shyft.to/how-to-get-parsed-pumpswap-amm-pools-on-solana-9af6f0828518",
      isNew: true,
    },
    {
      id: 11,
      blogName: "How to stream and parse Pumpswap transactions on Solana",
      blogLink:
        "https://blogs.shyft.to/how-to-stream-and-parse-pumpswap-transactions-on-solana-87e4b181ad40",
      isNew: true,
    },
  ];

  const replits = {
    defaultReps: [
      {
        id: 1,
        blogName: "How to get parsed transactions from jupiter v6",
        blogLink:
          "https://replit.com/@shyft-to/get-parsed-transaction-of-jupiter-v6-from-grpc?v=1",
        isNew: false,
      },
      {
        id: 2,
        blogName: "How to get liquidity details of a token",
        blogLink: "https://replit.com/@shyft-to/gRpc-defiLiquidityDetails?v=1",
        isNew: true,
      },
      {
        id: 3,
        blogName: "How to create a Solana Arbitrage Bot",
        blogLink: "https://replit.com/@shyft-to/grpcarbitrage?v=1",
        isNew: true,
      },
      {
        id: 4,
        blogName: "How to get parsed meteora transactions",
        blogLink:
          "https://replit.com/@shyft-to/get-parsed-transaction-of-meteora-from-grpc?v=1",
        isNew: false,
      },
    ],
    basicReps: [
      {
        id: 1,
        blogName: "How to make a new gRPC connection on Solana",
        blogLink: "https://replit.com/@shyft-to/making-a-grpc-connection?v=1",
        isNew: false,
      },
      {
        id: 2,
        blogName:
          "How to add a reconnection mechanism to your existing gRPC connection",
        blogLink:
          "https://replit.com/@shyft-to/adding-a-reconnect-mechanism-to-grpc?v=1",
        isNew: true,
      },
      {
        id: 3,
        blogName:
          "How to modify your current gRPC subscribe request without disconnecting your stream",
        blogLink:
          "https://replit.com/@shyft-to/modifying-subscribe-request-grpc?v=1",
        isNew: true,
      },
    ],
    raydiumRepls: [
      {
        id: 1,
        blogName: "How to get parsed Raydium amm instructions from gRPC",
        blogLink:
          "https://replit.com/@shyft-to/get-parsed-instructions-of-raydium-amm-from-grpc?v=1",
        isNew: false,
      },
      {
        id: 2,
        blogName: "How to track newly created pools on Raydium using gRPC",
        blogLink:
          "https://replit.com/@shyft-to/track-new-liquidity-pools-created-on-raydium-dex-using-grpc?v=1",
        isNew: true,
      },
      // {
      //   id: 3,
      //   blogName: "How to track Pump.fun token migrations to RAYDIUM",
      //   blogLink: "https://replit.com/@shyft-to/grpc-monitor-pumpfun-token-migration-raydium?v=1",
      //   isNew: false,
      // },
      {
        id: 4,
        blogName: "How to get live token prices on Raydium",
        blogLink: "https://replit.com/@shyft-to/RaydiumPrice?v=1",
        isNew: false,
      },
    ],
    pumpfunRepls: [
      {
        id: 1,
        blogName: "How to get parsed Pump.fun transactions using gRPC",
        blogLink:
          "https://replit.com/@shyft-to/get-parsed-transaction-of-pump-fun-from-grpc?v=1",
        isNew: false,
      },
      {
        id: 2,
        blogName: "How to get monitor Pump.fun token migrations in real-time",
        blogLink:
          "https://replit.com/@shyft-to/grpc-monitor-pumpfun-token-migration-raydium?v=1",
        isNew: false,
      },
      {
        id: 3,
        blogName: "How to get check Pump.fun token migration progress",
        blogLink: "https://replit.com/@shyft-to/grpc-Pumpfun-Progress?v=1",
        isNew: true,
      },
      {
        id: 4,
        blogName: "How to get real-time Pump.fun token prices",
        blogLink: "https://replit.com/@shyft-to/PumpfunPrice?v=1",
        isNew: false,
      },
    ],
    orcaRepls: [
      {
        id: 1,
        blogName: "How to get parsed accounts from Orca using gRPC",
        blogLink:
          "https://replit.com/@shyft-to/get-parsed-accounts-of-orca-from-grpc?v=1",
        isNew: true,
      },
      {
        id: 2,
        blogName: "How to get parsed Orca transactions using Shyft gRPC",
        blogLink:
          "https://replit.com/@shyft-to/get-parsed-transaction-of-orca-from-grpc?v=1",
        isNew: false,
      },

      {
        id: 3,
        blogName: "How to get parsed add liquidity transactions for Orca",
        blogLink:
          "https://replit.com/@shyft-to/grpc-orca-txn-liquidityadded?v=1",
        isNew: false,
      },
      {
        id: 4,
        blogName: "How to get real-time prices for Orca Dex",
        blogLink: "https://replit.com/@shyft-to/OrcaPrice?v=1",
        isNew: false,
      },
    ],
  };

  const GithubLinks = {
    generalLinks: [
      {
        id: 6,
        blogName: "More gRPC streaming examples",
        blogLink:
          "https://github.com/Shyft-to/solana-defi/tree/main/general-grpc-examples",
        isNew: true,
      },
    ],
    raydiumLinks: [
      {
        id: 4,
        blogName:
          "Stream and parse Raydium Launchpad transactions on Solana using gRPC",
        blogLink:
          "https://github.com/Shyft-to/solana-defi/tree/main/Raydium/Typescript/stream_and_parse_raydium_launchpad_transactions",
        isNew: true,
      },
      {
        id: 6,
        blogName: "More streaming examples on Raydium",
        blogLink: "https://github.com/Shyft-to/solana-defi/tree/main/Raydium",
        isNew: true,
      },
    ],
    pumpfunLinks: [
      {
        id: 1,
        blogName:
          "Streaming and parsing new Pumpswap AMM Transactions on Solana using gRPC",
        blogLink:
          "https://github.com/Shyft-to/solana-defi/tree/main/PumpFun/Typescript/stream_new_pool_pumpfun_amm_transactions",
        isNew: true,
      },
      {
        id: 3,
        blogName: "More streaming examples on Pumpfun",
        blogLink: "https://github.com/Shyft-to/solana-defi/tree/main/PumpFun",
        isNew: true,
      },
    ],
    meteoraLinks: [
      {
        id: 1,
        blogName:
          "Streaming & parsing Meteora DLMM transactions on Solana using gRPC",
        blogLink:
          "https://github.com/Shyft-to/solana-defi/tree/main/Meteora/Typescript/stream_and_parse_meteora_dlmm_transactions",
        isNew: true,
      },
      {
        id: 2,
        blogName: "Streaming & parsing Meteora Pools Data using gRPC",
        blogLink:
          "https://github.com/Shyft-to/solana-defi/tree/main/Meteora/Typescript/stream_and_parse_meteora_pools_transactions",
        isNew: false,
      },
      {
        id: 3,
        blogName: "More streaming examples on Meteora",
        blogLink: "https://github.com/Shyft-to/solana-defi/tree/main/Meteora",
        isNew: true,
      },
    ],
    orcaLinks: [
      {
        id: 1,
        blogName: "Streaming & parsing Orca Whirlpool transactions using gRPC",
        blogLink:
          "https://github.com/Shyft-to/solana-defi/tree/main/Orca/Typescript/stream_and_parse_whirlpool_transactions",
        isNew: false,
      },
      {
        id: 3,
        blogName: "More streaming examples on Orca Whirlpool",
        blogLink: "https://github.com/Shyft-to/solana-defi/tree/main/Orca",
        isNew: false,
      },
    ],
  };

  return (
    <Stack as="div" bg={"#111"}>
      <Container
        id="learn-solana-development-with-shyft"
        maxW={"7xl"}
        pt={{ base: 6, md: 12 }}
        pb={{ base: 3, md: 19 }}
      >
        <Stack spacing={12}>
          <CombinedHeading
            topHeading="Learn gRPC Development"
            mainHeading="Solana gRPC Examples"
            subHeading="The ultimate resource hub for gRPC development with use case specific blogs, example code and replits in multiple languages."
            isCenter={true}
          />
          <Flex
            w={"full"}
            flexDirection={{ base: "column", md: "row" }}
            justifyContent={"space-between"}
            flexWrap={{ base: "wrap" }}
            pb={{ base: 12, md: "72px" }}
            display={{ base: "none", md: "flex" }}
          >
            <Box w={{ base: "full", md: "30%" }}>
              <Stack mt={{ base: "8px", md: "12px" }} pb={"8px"}>
                <Box
                  bgColor={"brand.faintGrey"}
                  borderRadius={"4px"}
                  py={{ base: "6px" }}
                  textAlign={"center"}
                >
                  <Heading
                    fontSize={{ base: "md", md: "lg" }}
                    fontWeight={"200"}
                    fontFamily={"heading"}
                    color={"brand.white"}
                    mb={0}
                  >
                    gRPC Blogs
                  </Heading>
                </Box>
                <Box py={3}>
                  <UnorderedList
                    styleType="none"
                    color={"brand.white"}
                    spacing={"5"}
                    ms={"-3"}
                  >
                    {grpcBlogs.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text lineHeight={"19px"} fontSize={"16px"}>
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              </Stack>
            </Box>
            <Box w={{ base: "full", md: "30%" }}>
              <Stack mt={{ base: "8px", md: "12px" }} pb={"8px"}>
                <Box
                  bgColor={"brand.faintGrey"}
                  borderRadius={"4px"}
                  py={{ base: "6px" }}
                  textAlign={"center"}
                >
                  <Heading
                    fontSize={{ base: "md", md: "lg" }}
                    fontWeight={"200"}
                    fontFamily={"heading"}
                    color={"brand.white"}
                    mb={0}
                  >
                    Getting Started with gRPC
                  </Heading>
                </Box>
                <Box py={3}>
                  <UnorderedList
                    styleType="none"
                    color={"brand.white"}
                    spacing={"4"}
                    ms={"-3"}
                  >
                    {replits.basicReps.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text
                            as={"div"}
                            lineHeight={"19px"}
                            fontSize={"16px"}
                          >
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <ReplBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                    {GithubLinks.generalLinks.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text
                            as={"div"}
                            lineHeight={"19px"}
                            fontSize={"16px"}
                          >
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <GitBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              </Stack>
              <Stack mt={{ base: "8px", md: "12px" }} pb={"8px"}>
                <Box
                  bgColor={"brand.faintGrey"}
                  borderRadius={"4px"}
                  py={{ base: "6px" }}
                  textAlign={"center"}
                >
                  <Heading
                    fontSize={{ base: "md", md: "lg" }}
                    fontWeight={"200"}
                    fontFamily={"heading"}
                    color={"brand.white"}
                    mb={0}
                  >
                    Raydium gRPC Examples
                  </Heading>
                </Box>
                <Box py={3}>
                  <UnorderedList
                    styleType="none"
                    color={"brand.white"}
                    spacing={"4"}
                    ms={"-3"}
                  >
                    {replits.raydiumRepls.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text
                            as={"div"}
                            lineHeight={"19px"}
                            fontSize={"16px"}
                          >
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <ReplBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                    {GithubLinks.raydiumLinks.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text
                            as={"div"}
                            lineHeight={"19px"}
                            fontSize={"16px"}
                          >
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <GitBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              </Stack>
              <Stack mt={{ base: "8px", md: "12px" }} pb={"8px"}>
                <Box
                  bgColor={"brand.faintGrey"}
                  borderRadius={"4px"}
                  py={{ base: "6px" }}
                  textAlign={"center"}
                >
                  <Heading
                    fontSize={{ base: "md", md: "lg" }}
                    fontWeight={"200"}
                    fontFamily={"heading"}
                    color={"brand.white"}
                    mb={0}
                  >
                    Meteora gRPC Examples
                  </Heading>
                </Box>
                <Box py={3}>
                  <UnorderedList
                    styleType="none"
                    color={"brand.white"}
                    spacing={"4"}
                    ms={"-3"}
                  >
                    {GithubLinks.meteoraLinks.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text
                            as={"div"}
                            lineHeight={"19px"}
                            fontSize={"16px"}
                          >
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <GitBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              </Stack>
            </Box>
            <Box w={{ base: "full", md: "30%" }}>
              <Stack mt={{ base: "8px", md: "12px" }} pb={"8px"}>
                <Box
                  bgColor={"brand.faintGrey"}
                  borderRadius={"4px"}
                  py={{ base: "6px" }}
                  textAlign={"center"}
                >
                  <Heading
                    fontSize={{ base: "md", md: "lg" }}
                    fontWeight={"200"}
                    fontFamily={"heading"}
                    color={"brand.white"}
                    mb={0}
                  >
                    Pump.fun gRPC Examples
                  </Heading>
                </Box>

                <Box pt={3}>
                  <UnorderedList
                    styleType="none"
                    color={"brand.white"}
                    spacing={"4"}
                    ms={"-3"}
                  >
                    {replits.pumpfunRepls.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text lineHeight={"19px"} fontSize={"16px"}>
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <ReplBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                    {GithubLinks.pumpfunLinks.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text lineHeight={"19px"} fontSize={"16px"}>
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <GitBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              </Stack>
              <Stack mt={{ base: "8px", md: "12px" }} pb={"8px"}>
                <Box
                  bgColor={"brand.faintGrey"}
                  borderRadius={"4px"}
                  py={{ base: "6px" }}
                  textAlign={"center"}
                >
                  <Heading
                    fontSize={{ base: "md", md: "lg" }}
                    fontWeight={"200"}
                    fontFamily={"heading"}
                    color={"brand.white"}
                    mb={0}
                  >
                    Orca gRPC Examples
                  </Heading>
                </Box>
                <Box pt={3}>
                  <UnorderedList
                    styleType="none"
                    color={"brand.white"}
                    spacing={"4"}
                    ms={"-3"}
                  >
                    {replits.orcaRepls.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text lineHeight={"19px"} fontSize={"16px"}>
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <ReplBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                    {GithubLinks.orcaLinks.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text lineHeight={"19px"} fontSize={"16px"}>
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <GitBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              </Stack>
            </Box>
          </Flex>
          <Accordion
            allowToggle
            display={{ base: "initial", md: "none" }}
            mb={12}
          >
            <AccordionItem border={"none"} pt={2}>
              <h2>
                <AccordionButton
                  color={"brand.white"}
                  bg={"brand.lightGrey"}
                  borderRadius={"8px"}
                  _expanded={{ bg: "brand.red" }}
                >
                  <Box as="span" flex="1" textAlign="left">
                    gRPC Blogs
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Box py={3}>
                  <UnorderedList
                    styleType="none"
                    color={"brand.white"}
                    spacing={"4"}
                    ms={"-6"}
                  >
                    {grpcBlogs.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text lineHeight={"19px"} fontSize={"16px"}>
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem border={"none"} pt={2}>
              <h2>
                <AccordionButton
                  color={"brand.white"}
                  bg={"brand.lightGrey"}
                  borderRadius={"8px"}
                  _expanded={{ bg: "brand.red" }}
                >
                  <Box as="span" flex="1" textAlign="left">
                    Getting Started with gRPC
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Box py={3}>
                  <UnorderedList
                    styleType="none"
                    color={"brand.white"}
                    spacing={"4"}
                    ms={"-6"}
                  >
                    {replits.basicReps.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text
                            as={"div"}
                            lineHeight={"19px"}
                            fontSize={"16px"}
                          >
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <ReplBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                    {GithubLinks.generalLinks.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text
                            as={"div"}
                            lineHeight={"19px"}
                            fontSize={"16px"}
                          >
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <GitBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              </AccordionPanel>
            </AccordionItem>
            
            <AccordionItem border={"none"} pt={2}>
              <h2>
                <AccordionButton
                  color={"brand.white"}
                  bg={"brand.lightGrey"}
                  borderRadius={"8px"}
                  _expanded={{ bg: "brand.red" }}
                >
                  <Box as="span" flex="1" textAlign="left">
                    Raydium Examples
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Box py={3}>
                  <UnorderedList
                    styleType="none"
                    color={"brand.white"}
                    spacing={"4"}
                    ms={"-6"}
                  >
                    {replits.raydiumRepls.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text lineHeight={"19px"} fontSize={"16px"}>
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <ReplBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                    {GithubLinks.raydiumLinks.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text
                            as={"div"}
                            lineHeight={"19px"}
                            fontSize={"16px"}
                          >
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <GitBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem border={"none"} pt={2}>
              <h2>
                <AccordionButton
                  color={"brand.white"}
                  bg={"brand.lightGrey"}
                  borderRadius={"8px"}
                  _expanded={{ bg: "brand.red" }}
                >
                  <Box as="span" flex="1" textAlign="left">
                    Meteora Examples
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Box py={3}>
                  <UnorderedList
                    styleType="none"
                    color={"brand.white"}
                    spacing={"4"}
                    ms={"-6"}
                  >
                    {GithubLinks.meteoraLinks.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text
                            as={"div"}
                            lineHeight={"19px"}
                            fontSize={"16px"}
                          >
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <GitBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem border={"none"} pt={2}>
              <h2>
                <AccordionButton
                  color={"brand.white"}
                  bg={"brand.lightGrey"}
                  borderRadius={"8px"}
                  _expanded={{ bg: "brand.red" }}
                >
                  <Box as="span" flex="1" textAlign="left">
                    Pump.fun Examples
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Box py={3}>
                  <UnorderedList
                    styleType="none"
                    color={"brand.white"}
                    spacing={"4"}
                    ms={"-6"}
                  >
                    {replits.pumpfunRepls.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text lineHeight={"19px"} fontSize={"16px"}>
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <ReplBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                    {GithubLinks.pumpfunLinks.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text lineHeight={"19px"} fontSize={"16px"}>
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <GitBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              </AccordionPanel>
            </AccordionItem>

            <AccordionItem border={"none"} pt={2}>
              <h2>
                <AccordionButton
                  color={"brand.white"}
                  bg={"brand.lightGrey"}
                  borderRadius={"8px"}
                  _expanded={{ bg: "brand.red" }}
                >
                  <Box as="span" flex="1" textAlign="left">
                    Orca Examples
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Box py={3}>
                  <UnorderedList
                    styleType="none"
                    color={"brand.white"}
                    spacing={"4"}
                    ms={"-6"}
                  >
                    {replits.orcaRepls.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text lineHeight={"19px"} fontSize={"16px"}>
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <ReplBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                    {GithubLinks.orcaLinks.map((blog) => (
                      <ListItem key={blog.id}>
                        <Link
                          href={blog.blogLink}
                          target="_blank"
                          _hover={{
                            textDecoration: "none",
                            color: "brand.red",
                          }}
                        >
                          <Text lineHeight={"19px"} fontSize={"16px"}>
                            {blog.blogName}&nbsp;{blog.isNew && "🔥"}&nbsp;
                            <GitBadge />
                          </Text>
                        </Link>
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Box>
              </AccordionPanel>
            </AccordionItem>
            
          </Accordion>
        </Stack>
      </Container>
    </Stack>
  );
}

const ReplBadge = () => {
  return (
    <Text
      as="span"
      bg={"brand.yellow"}
      color={"brand.black"}
      fontWeight={"bold"}
      px={1}
      fontSize={"0.7rem"}
      lineHeight={"0"}
      borderRadius={"2px"}
    >
      Repl
    </Text>
  );
};
const GitBadge = () => {
  return (
    <Text
      as="span"
      bg={"brand.white"}
      color={"brand.black"}
      fontWeight={"bold"}
      px={1}
      fontSize={"0.7rem"}
      lineHeight={"0"}
      borderRadius={"2px"}
    >
      GitHub
    </Text>
  );
};
